'use strict';
const angular = require('angular');

export class calendarEventDetailComponent {
  /*@ngInject*/
  constructor(dialogs, CalendarEventService, $timeout) {
    this.dialogs = dialogs;
    this.CalendarEventService = CalendarEventService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.calendarEvent = this.resolve.calendarEvent;
    this.userHasPermission = this.resolve.config.userHasPermission;

    this.galleryImages = this.calendarEvent.attachments.filter(attachment => {
      return this.isImageMime(attachment.contentType);
    });

    this.galleryImages = this.galleryImages.map(function(obj){
      var rObj = {};

      rObj.title = obj.filename;
      rObj.alt = obj.filename;
      rObj.url = "/api/storage/" + obj._id;
      rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

      return rObj;
    });

    if (this.calendarEvent.location) {

      this.mapOptions = {
        zoom: 15,
        center: new google.maps.LatLng(this.calendarEvent.location.lat, this.calendarEvent.location.lng),
        mapTypeId: google.maps.MapTypeId.TERRAIN
      };

      var that = this;

      this.$timeout(() => {
        that.map = new google.maps.Map(document.getElementById('gMap'), that.mapOptions);

        var marker = new google.maps.Marker({
          map: that.map,
          position: new google.maps.LatLng(that.calendarEvent.location.lat, that.calendarEvent.location.lng),
          title: that.calendarEvent.location.address
        });

        marker.content = '<div class="infoWindowContent">' + that.calendarEvent.location.address + '</div>';

      },500);
    }

  }

  countPdfAttachments(attachs) {
    return attachs.reduce((acc, obj) => {
      return acc + this.isPdfMime(obj.contentType);
    }, 0);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  delete() {
    var that = this;
    var eventId = this.calendarEvent.eventId;

    var dlg = this.dialogs.confirm("Delete this Calendar Event?", "Do you really want to delete this calendar event?");
    dlg.result.then(() => {
      // OK delete it
      that.CalendarEventService.delete({id: eventId},
        () => {
          that.close({$value: {action: 'removed', id: eventId}});
        },
        err => {
          alert("Could not delete calendar event");
        });
    }, () => {
      // Cancel
    });
  }

  ok() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.calendarEventDetail', [])
  .component('calendarEventDetail', {
    template: require('./calendar-event-detail.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: calendarEventDetailComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/calendar/detail/calendar-event-detail.component.js